import { useEffect, useState } from "react";
import { api, errMsg } from "../../../lib/api";
import { useAuth } from "../../../context/AppContext";
import { Empty } from "../../../components/Common";

export const API_ORIGIN = process.env.REACT_APP_BACKEND_URL;
export const REG_STATUS = { on_kayit: "Ön kayıt", kesin_kayit: "Kesin kayıt", iptal: "İptal" };
export const SOURCES = { web: "Web sitesi", telefon: "Telefon", whatsapp: "WhatsApp", yuz_yuze: "Yüz yüze", sosyal_medya: "Sosyal medya", diger: "Diğer" };
export const CLASS_STATUS = { planlandi: "Planlandı", devam_ediyor: "Devam ediyor", tamamlandi: "Tamamlandı", iptal: "İptal" };
export const DOC_STATUS = { bekleniyor: "Bekleniyor", yuklendi: "Yüklendi", kontrol_edildi: "Kontrol edildi", yeniden_isteniyor: "Yeniden isteniyor" };
export const ATT = { var: "Var", yok: "Yok", gec: "Geç", izinli: "İzinli" };
export const FIELD_LABELS = {
  first_name: "Adı", last_name: "Soyadı", father_name: "Baba adı", tc_no: "T.C. kimlik no", birth_date: "Doğum tarihi", birth_place: "Doğum yeri",
  gender: "Cinsiyet", phone: "Telefon", email: "E-posta", address: "Adres", training_type: "Eğitim türü", course_id: "Eğitim (program)",
  period: "Eğitim dönemi", start_date: "Kurs başlangıcı", end_date: "Kurs bitişi", mother_name: "Anne adı", nationality: "Uyruk",
  education_level: "Öğrenim durumu", blood_type: "Kan grubu", phone2: "İkinci telefon", addr_city: "İl", addr_district: "İlçe",
  addr_neighborhood: "Mahalle", postal_code: "Posta kodu", emergency_name: "Acil durum kişisi", emergency_relation: "Yakınlık", emergency_phone: "Acil durum telefonu",
};
export const EDUCATION = { ilkokul: "İlkokul", ortaokul: "Ortaokul", lise: "Lise", onlisans: "Ön lisans", lisans: "Lisans", yukseklisans: "Yüksek lisans" };
export const BLOOD = Object.fromEntries(["0+", "0-", "A+", "A-", "B+", "B-", "AB+", "AB-"].map((b) => [b, b]));
export const ILLER = "Adana,Adıyaman,Afyonkarahisar,Ağrı,Aksaray,Amasya,Ankara,Antalya,Ardahan,Artvin,Aydın,Balıkesir,Bartın,Batman,Bayburt,Bilecik,Bingöl,Bitlis,Bolu,Burdur,Bursa,Çanakkale,Çankırı,Çorum,Denizli,Diyarbakır,Düzce,Edirne,Elazığ,Erzincan,Erzurum,Eskişehir,Gaziantep,Giresun,Gümüşhane,Hakkari,Hatay,Iğdır,Isparta,İstanbul,İzmir,Kahramanmaraş,Karabük,Karaman,Kars,Kastamonu,Kayseri,Kırıkkale,Kırklareli,Kırşehir,Kilis,Kocaeli,Konya,Kütahya,Malatya,Manisa,Mardin,Mersin,Muğla,Muş,Nevşehir,Niğde,Ordu,Osmaniye,Rize,Sakarya,Samsun,Siirt,Sinop,Sivas,Şanlıurfa,Şırnak,Tekirdağ,Tokat,Trabzon,Tunceli,Uşak,Van,Yalova,Yozgat,Zonguldak".split(",");

let cache = null;
export function useMeta() {
  const { user } = useAuth();
  const uid = user?.id;
  const [m, setM] = useState(cache?.uid === uid ? cache.data : null);
  useEffect(() => {
    if (cache?.uid === uid) { setM(cache.data); return; }
    api.get("/admin/school/meta").then((r) => { cache = { uid, data: r.data }; setM(r.data); }).catch((x) => setM({ error: errMsg(x) }));
  }, [uid]);
  return m;
}
export const resetMeta = () => { cache = null; };

export const Forbidden = ({ text }) => <Empty text={text || "Bu işlem için yetkiniz yok"} testid="forbidden" />;

export const STable = ({ cols, rows, testid, empty = "Kayıt yok." }) => rows.length ? (
  <div className="overflow-x-auto bg-white border border-zinc-200 rounded-xl shadow-sm" data-testid={testid}>
    <table className="w-full text-sm"><thead className="bg-zinc-50 text-left text-[11px] font-bold uppercase tracking-wider text-zinc-600 border-b border-zinc-200"><tr>{cols.map(([l]) => <th key={l} className="px-4 py-3 whitespace-nowrap">{l}</th>)}</tr></thead>
      <tbody>{rows.map((r) => <tr key={r.id || r.registration_id} className="border-t border-zinc-100 hover:bg-zinc-50/80">{cols.map(([l, fn]) => <td key={l} className="px-4 py-3 align-top">{fn(r)}</td>)}</tr>)}</tbody></table>
  </div>) : <Empty text={empty} />;

export const Field = ({ label, id, children }) => <div><label className="label" htmlFor={id}>{label}</label>{children}</div>;

export const Sel = ({ value, onChange, options, empty, testid, id, className = "field" }) => (
  <select id={id} className={className} value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
    {empty !== undefined && <option value="">{empty}</option>}
    {Object.entries(options).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
  </select>
);

export function daysLabel(n) {
  if (n === null || n === undefined) return "";
  if (n < 0) return `${-n} gün geçti`;
  if (n === 0) return "Bugün";
  return `${n} gün kaldı`;
}

export const PageHead = ({ title, sub, children }) => <div className="flex flex-wrap justify-between items-end gap-3 mb-6"><div><h1 className="text-2xl sm:text-3xl font-black tracking-tight text-zinc-900">{title}</h1>{sub && <p className="text-sm text-zinc-500 mt-1">{sub}</p>}</div><div className="flex flex-wrap gap-2">{children}</div></div>;
